var _defs, _polygon, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack197({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 14.71 15 7.88 1 7.88 8 14.71"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.02,
    y1: 1.29,
    x2: 11.98,
    y2: 1.29
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 8.19,
    x2: 8,
    y2: 1.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack197);
export default __webpack_public_path__ + "static/media/Symbolpack_1_97.e882c946a5d52e3b345439ebd3aa053c.svg";
export { ForwardRef as ReactComponent };